import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
let _vm = new Vue()

export default {
  namespaced: true,
  state: {
    labelDetails: {},
    form: {},
    filterDistData: [],
    timeRanges: null,
    conditionSearchTypeName: '',
    searchTabType: '', // 搜索种类的type值
    h5RealTime: null,
    payWayList: [], // 支付方式
    choosePayWay: '',
    industryList: [],
    indusCodeMap: {},
    pkgContracts: [],
    cprPlusModeList: [
      {
        label: '标准',
        value: 1
      }, {
        label: '高级',
        value: 2
      }
    ]
  },
  mutations: {
    setData(state, data) {
      let { key, value } = data
      if (Array.isArray(key)) {
        let zhizhen = ''
        while (key.length > 0) {
          zhizhen += "['" + key.shift() + "']"
        }
        eval("state" + zhizhen + '=' + JSON.stringify(value))
      } else {
        state[key] = value
      }
    },
    setCoditionSearchType(state, data) { state.conditionSearchTypeName = data },
    setH5RealTime(state, data) { state.h5RealTime = data },
    setPayWayList(state, data) { state.payWayList = data },
    setPayWay(state, data) { state.choosePayWay = data },
    setForm(state, data) { state.form = data },
    setTimeRanges(state, data) { state.timeRanges = data },
    setFilterDistData(state, data) {    // 设置快速发布筛选出来的小区数据
      state.filterDistData = data
      // state.filterDistData.amount = data.amount
      // state.filterDistData.data = data.data
      // state.filterDistData.deviceCount = data.deviceCount
    },
    setLabelDetails(state, data) {
      Vue.set(state.labelDetails, data.key, data.value);
    }
  },
  actions: {
    async getPayWay({ commit }) { // 获取支付方式(包含会员权益)
      let res = await _vm.fetch('/boss/payment/v2/getPayWay', '', 'get')
      if (res && res.code == 0 && res.data && res.data.length) commit('setPayWayList', res.data)
    },
    async getTimeRanges({ commit }) {
      let timesAll = await _vm.fetch('/boss/common/config/v2/getFrequencyTree', '', 'get')
      timesAll && timesAll.data && commit('setTimeRanges', timesAll.data)
    },
    async getIndustryList({ commit }) {
      let res = await _vm.fetch('/boss/app/search/v3/industries', '', 'get')
      if (res && res.code == 0 && res.data) {
        let list = res.data.industries || []
        commit('setData', { key: 'industryList', value: list })
        commit('setData', { key: 'indusCodeMap', value: handleIndusCodeMap(list) })
      }
    }
  }
}

function handleIndusCodeMap(list) {
  let data = {}
  list.forEach(el => {
    el.subIndustries.forEach(ele => {
      data[ele.code] = ele
      data[ele.code].pData = { name: el.name, code: el.code }
    })
  })
  return data
}
